import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import BookingModal from './components/booking/BookingModal';
import AnnouncementBar from './components/promotions/AnnouncementBar';

// Pages
import { appRoutes } from './routes/config';

// Contexts
import { BookingProvider } from './contexts/BookingContext';
import { SiteInfoProvider } from './contexts/SiteInfoContext';
import { AuthProvider } from './contexts/AuthContext';

// API
import { contentAPI } from './services/api';

function App() {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await contentAPI.getAnnouncements();
        const data = response.data;
        // Handle both array and paginated response
        const list = Array.isArray(data) ? data : (data.results || []);
        setAnnouncements(list);
      } catch (error) {
        console.error('Failed to fetch announcements:', error);
      }
    };
    fetchAnnouncements();
  }, []);

  return (
    <AuthProvider>
      <SiteInfoProvider>
        <BookingProvider>
          <div className="App">
            {announcements.length > 0 && (
              <AnnouncementBar announcements={announcements} />
            )}
            <Navbar />
            <main>
              <Routes>
                {appRoutes.map((route) => (
                  <Route key={route.key} path={route.path} element={route.element} />
                ))}
              </Routes>
            </main>
            <Footer />
            <BookingModal />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </BookingProvider>
      </SiteInfoProvider>
    </AuthProvider>
  );
}

export default App;
